import { idleIdlingKey } from "../constants/keys";

export const crossTabIdleListen = (api) => {
    const interval = setInterval(() => {
        if (JSON.parse(localStorage.getItem(idleIdlingKey) === false) && api.IsPrompted()) {
            api.activate();
        }
    }, 1000);
    return interval;
};

export const createCounter = (countdownTo) => {
    return () => {
        const currentCount = Math.floor((countdownTo - Date.now())/1000);
        return currentCount > -1 ? currentCount : 0;
    };
};//countdownTo is a date object